import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing photo module from webix
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the FilterBonusReportView.
 * @extends JetView
 */
export default class FilterBonusReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with date and bonus type selectors
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting result date type
                    name: 'ResultDate',
                    localId: 'timeTypes:combo',
                    label: _('Tipo de tiempo'), // Label for the dropdown
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options to be populated later
                },
                {
                    view: 'richselect', // Dropdown for selecting bonus type
                    name: 'BonusType',
                    localId: 'bonusTypes:combo',
                    label: _('Tipo'), // Label for the dropdown
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options to be populated later
                },
            ],
        };

        // Center left section with date picker and acceptance type selector
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange', // CSS class for styling
                    readonly: true, // Make the input read-only
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
                {
                    view: 'richselect', // Dropdown for selecting acceptance type
                    name: 'AcceptanceType',
                    localId: 'bonusStates:combo',
                    label: _('Estado'), // Label for the dropdown
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options to be populated later
                },
            ],
        };

        // Center right section with client bonus ID input
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for client bonus ID
                    name: 'ClientBonusId',
                    type: 'number', // Input type is number
                    label: _('Partner Bono Id'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Partner Bono Id'), // Placeholder text
                    invalidMessage: _('Partner Bonus Id is required'), // Error message for validation
                },
            ],
        };

        // Right section with partner bonus ID input
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for partner bonus ID
                    name: 'PartnerBonusId',
                    type: 'number', // Input type is number
                    label: _("<span class='icon-id'></span> ID"), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('ID'), // Placeholder text
                    invalidMessage: _('ID is required'), // Error message for validation
                },
            ],
        };

        // Upper section containing all input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive layout
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Columns for layout
                },
            ],
        };

        // Buttons for clearing and submitting the form
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear the form fields
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event with form data
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [upper_section, buttons], // Rows containing input fields and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
